export const CATEGORIES = 'Categories'
export const SUB_CATEGORIES = 'SubCategories'
export const CATEGORIES_COUNT_BEFORE_EXPAND = 10
export const SUB_CATEGORIES_COUNT_BEFORE_EXPAND = 5
